export var DepositType;
(function (DepositType) {
    DepositType["NONE"] = "none";
    DepositType["HEAD"] = "head";
    DepositType["MEAL"] = "meal";
})(DepositType || (DepositType = {}));
